module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article.d0e4f7c0.webp";